export default __webpack_public_path__ + "images/GY.d2e78e1.png";